enum OpportunityStage {
    Undefined = -1,
    New = 10,
    Qualified = 20,
    Proposing = 30,
    Negotiating = 40,
    Won = 90,
    Lost = 95,
}

export const OpportunityStageLabels: Record<number, string> = {
    [OpportunityStage.New]: 'New',
    [OpportunityStage.Qualified]: 'Qualified',
    [OpportunityStage.Proposing]: 'Proposing',
    [OpportunityStage.Negotiating]: 'Negotiating',
    [OpportunityStage.Won]: 'Won',
    [OpportunityStage.Lost]: 'Lost',
};

export default OpportunityStage;
